import styled from '@emotion/styled';

import { useField } from 'formik';

import { FormControlLabel, Radio, RadioGroup, FormLabel } from '@mui/material';

const RadioButtons = ({ label, fields = [], row = true, ...props }) => {
  const [field] = useField(props);
  return (
    <RadioGroup
      {...field}
      {...props}
      row={row}
    >
      {fields.map((field) => (
        <FormControlLabel key={field.value} value={field.value} control={<Radio />} label={field.label} />
      ))}
    </RadioGroup>
  );
};

export default RadioButtons;